<template>
  <div class="cursor_detail">
    <!-- cursorDefault.png  :src="url"-->
    <div class="cursor_inner" @click="handCkick">
      <el-image
        style="width: 100%; height: 160px; display: block; background: #292929"
        :src="cursorDetail.cover || defaultImg"
        fit="fill"
        lazy
      ></el-image>
      <div class="cursor_content" :style="{ height: dHeight + 'px' }">
        <div class="equal" ref="equal">
          <h4 class="ellipsis" :title="cursorDetail.title">{{ cursorDetail.title }}</h4>
          <div class="sublit">
            <p>主讲教师：{{ cursorDetail.teacherName }}</p>
            <!-- <span>{{
              cursorDetail.classHours
                ? parseInt((cursorDetail.classHours / 60 / 45) * 100) / 100 + "课时"
                : ""
            }}</span> -->
            <span>{{ cursorDetail.chapterCount }}节课</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cursorDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      defaultImg: require("@/assets/images/cursorDefault.png"),
    };
  },
  mounted() {
    // 等高方法
    this.$nextTick(() => {
      this.$emit("setEqual", this.$refs.equal.clientHeight);
    });
  },
  methods: {
    handCkick() {
      this.$emit("setHandleDetail", this.cursorDetail);
    },
  },
};
</script>
<style lang="scss" scoped>
.cursor_detail {
  //   width: 33.33%;
  padding: 0 7px;
  margin-bottom: 33px;
  .cursor_inner {
    overflow: hidden;
    cursor: pointer;
    
    transition: all 0.3s;
    
    &:hover {
      transform: translateY(-6px);
      box-shadow: 0px 0px 13px 0px rgba(53,87,73,0.14);
      
    }
  }
}

.cursor_content {
  border: 1px solid;
  border-color: #EEEEEE;
  border-top-color: transparent;
  .equal {
    padding: 15px;
    
    h4 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      margin-bottom: 10px;
    }
    .sublit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #fff;
        line-height: 1;
        white-space: nowrap;
        background: url('~@/assets/images/usertype/baiqian_yi.png');
        background-size: cover;
        border-radius: 10px;
        font-size: 12px;
        padding: 3px 9px;
      }
      p {
        color: #999999;
        font-size: 12px;
      }
    }
  }
}
</style>
